import { render, staticRenderFns } from "./IDDelete.vue?vue&type=template&id=0fcbb0d6"
import script from "./IDDelete.vue?vue&type=script&lang=js"
export * from "./IDDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports